import React, { useEffect, useState } from 'react';

export const Expire = (props) => {
  const { retries } = props;
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
  }, [retries]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [retries]);

  return visible ? retries !== 1 ? <>{props.children}</> : null : null;
};
